import { NgIf, NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { LaunchpadNewsCardProps, LaunchpadTileConfig } from "../../container/launchpad.interfaces";
import { InnerNewsCardComponent } from "./inner-news-card/inner-news-card.component";

@Component({
  selector: "tpm-module-card",
  templateUrl: "module-card.component.html",
  styleUrls: ["module-card.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgOptimizedImage, TranslateModule, CardModule, IconModule, EneButtonModule, InnerNewsCardComponent]
})
export class ModuleCardComponent {
  @Output() readonly moduleCardClicked = new EventEmitter<string>();
  @Output() readonly storytellerButtonClicked = new EventEmitter<string>();
  @Output() readonly leadButtonClicked = new EventEmitter<string>();
  @Output() readonly productButtonClicked = new EventEmitter<string>();
  @Output() readonly innerNewsCardButtonClicked = new EventEmitter<LaunchpadNewsCardProps>();

  @Input({ required: true }) props: LaunchpadTileConfig;
  @Input() newsProps: LaunchpadNewsCardProps | undefined;
  @Input() isMobile: boolean | undefined;

  onClick({
    event,
    eventEmitter,
    value
  }: {
    event: Event | null;
    eventEmitter: EventEmitter<string | LaunchpadNewsCardProps>;
    value: string | LaunchpadNewsCardProps;
  }): void {
    event?.stopPropagation();
    eventEmitter.emit(value);
  }
}
